import { communicationUrlQuery } from 'Services/baseQuery'
import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import { ISendEmail } from 'Models/RequestModels'
import { ISendSMS } from 'Models/RequestModels/ACL'

export const communicationApi = createApi({
  reducerPath: 'communicationApi',
  baseQuery: communicationUrlQuery,
  endpoints: (builder) => ({
    sendEmail: builder.mutation<any, ISendEmail>({
      query: (payload: ISendEmail) => ({
        url: API_ENDPOINTS.HEALTH_SEND_EMAIL,
        method: 'POST',
        body: payload,
      }),
    }),
    sendSms: builder.mutation<any, ISendSMS>({
      query: (payload: ISendSMS) => ({
        url: API_ENDPOINTS.SEND_SMS,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
})

export const {
  useSendEmailMutation,
  useSendSmsMutation
} = communicationApi
